export function useDateHelpers() {
  const easyToReadDate = (dateSeconds, dateObjectProvided = false) => {
    if (!dateSeconds) return;
    let date = dateSeconds;
    if (!dateObjectProvided) {
      date = new Date(dateSeconds * 1000);
    }
    let currentDate = new Date();

    // Create separate date objects for the date comparison
    let compareDate = new Date(date.getTime());
    let compareCurrentDate = new Date(currentDate.getTime());

    // Reset the time part of the dates to ensure we're comparing only the date part
    compareDate.setHours(0, 0, 0, 0);
    compareCurrentDate.setHours(0, 0, 0, 0);

    let formattedDate;

    // Calculate the difference in days
    let diffInDays = Math.floor(
      (compareCurrentDate - compareDate) / (1000 * 60 * 60 * 24),
    );

    // Format the time
    let timeOptions = { hour: "2-digit", minute: "2-digit" };
    let time = date.toLocaleTimeString("en-GB", timeOptions);

    // Determine the date label
    if (diffInDays === 0) {
      formattedDate = `Today, ${time}`;
    } else if (diffInDays === 1) {
      formattedDate = `Yesterday, ${time}`;
    } else {
      // UK date with day and time
      let dateOptions = {
        weekday: "short",
        day: "numeric",
        month: "numeric",
        year: "numeric",
      };
      formattedDate = `${date.toLocaleString("en-GB", dateOptions)}, ${time}`;
    }

    return formattedDate;
  };

  return {
    easyToReadDate,
  };
}
